import { Box, Flex, chakra } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import CollapsibleFlex from '../CollapsibleFlex';
import ContentContainer from '../ContentContainer';

type HeroProps = {
  children?: ReactNode;
  image?: string | ReactNode;
  gradientPattern?: keyof typeof GradientPatterns;
  className?: string;
  banner?: ReactNode;
  centerChildren?: boolean;
};

/**
 * Hero component
 */

export default chakra(function Hero({
  children,
  gradientPattern,
  className,
  banner,
  centerChildren,
}: HeroProps) {
  return (
    <Flex className={className} pos='relative' py='150px'>
      {gradientPattern && (
        <Box pos='absolute' top={0} left={0} w='100%' h='100%' zIndex={0}>
          {GradientPatterns[gradientPattern]}
        </Box>
      )}

      {!!banner && (
        <Box pos='absolute' top='0' left='0' w='100%'>
          {banner}
        </Box>
      )}

      <ContentContainer style={{ paddingTop: 0, paddingBottom: 0 }}>
        <CollapsibleFlex
          alignItems={centerChildren ? 'center' : 'normal'}
          justifyContent={centerChildren ? 'center' : 'normal'}
        >
          {children}
        </CollapsibleFlex>
      </ContentContainer>
    </Flex>
  );
});

const GradientPatterns = {
  // Yellow blurred radial
  1: (
    <Box
      w='100%'
      height='100%'
      bg='radial-gradient(42.3% 65.39% at 87.12% 5.15%, rgba(9, 166, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(22.47% 47.46% at 47.35% 48.5%, #FFFAE1 0%, rgba(255, 255, 255, 0.0001) 85.19%);'
    />
  ),
  // Blue blurred radial
  2: (
    <Box
      w='100%'
      height='100%'
      bg='radial-gradient(42.3% 65.39% at 87.12% 5.15%, rgba(9, 166, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(22.47% 47.46% at 47.35% 48.5%, #E1FFFD 0%, rgba(255, 255, 255, 0.0001) 85.19%)'
    />
  ),
  // yellow linear gradient
  3: (
    <Box
      w='100%'
      h='100%'
      bg='radial-gradient(41.38% 102.88% at 81.95% -0.82%, rgba(9, 166, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(41.82% 102.72% at 30.16% 30.14%, #FFFCED 0%, rgba(255, 255, 255, 0.0001) 100%)'
      transform='matrix(-1, 0, 0, 1, 0, 0);'
    />
  ),
  4: (
    <Box
      w='100%'
      h='100%'
      bg='radial-gradient(41.38% 93.28% at 81.95% -0.75%, rgba(9, 166, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(41.82% 93.14% at 30.16% 27.33%, #FFFCED 0%, rgba(255, 255, 255, 0.0001) 100%)'
      transform='matrix(-1, 0, 0, 1, 0, 0)'
    />
  ),
  5: (
    <Box
      w='100%'
      h='100%'
      bg='linear-gradient(98.26deg, #071028 0%, #1F3058 100%)'
      opacity={0.8}
    />
  ),
  6: (
    <Box
      w='100%'
      h='100%'
      bg='linear-gradient(180deg, #F0F3F9 0%, rgba(240, 243, 249, 0) 100%)'
    />
  ),
  // blue gradient
  7: (
    <Box
      w='100%'
      h='100%'
      bg='linear-gradient(180deg, #00A5E4 0%, #0386D0 100%)'
    />
  ),
};
